// extracted by mini-css-extract-plugin
export default {"tagList":"style_tagList__-y8aW","tagItem":"style_tagItem__lmd8S","tagItemSelected":"style_tagItemSelected__oBCqV"};